<template>
    <section id="team">
        <b-row>
            <b-col>
                <h3>
                    Who are we?
                </h3>
                <h2 class="mb-4">
                    Meet the team.
                </h2>
            </b-col>
            <hooper
                class="hooper"
                :infiniteScroll="true"
                :autoPlay="true"
                :itemsToShow="visibleCount"
                :playSpeed="6000"
                :key="`testimonials-${visibleCount}-${windowWidthVar}`"
            >
                <slide>
                    <b-card class="team-member">
                        <div class="avatar-linkedin-wrapper">
                            <img src="../assets/images/engel.png" class="crop-circle"/>
                            <a href="https://www.linkedin.com/in/engelhamer" target="_blank" class="btn pill blue-button">
                                <v-icon name="brands/linkedin" scale="1.2"/>
                            </a>
                        </div>
                        <h5>
                            Engel Hamer
                        </h5>
                        <h3>
                            Founder, business development
                        </h3>
                    </b-card>
                </slide>
                <slide>
                    <b-card class="team-member">
                        <div class="avatar-linkedin-wrapper">
                            <img src="../assets/images/lars.jpg" class="crop-circle"/>
                            <a href="https://www.linkedin.com/in/lars-van-hijfte-a5786510b/" target="_blank" class="btn pill blue-button">
                                <v-icon name="brands/linkedin" scale="1.2"/>
                            </a>
                        </div>
                        <h5>
                            Lars van Hijfte
                        </h5>
                        <h3>
                            Founder, technology & integrations
                        </h3>
                    </b-card>
                </slide>
                <slide>
                    <b-card class="team-member">
                        <div class="avatar-linkedin-wrapper">
                            <img src="../assets/images/maarten.jpg" class="crop-circle"/>
                            <a href="https://www.linkedin.com/in/mjvkeulen" target="_blank" class="btn pill blue-button">
                                <v-icon name="brands/linkedin" scale="1.2"/>
                            </a>
                        </div>
                        <h5>
                            Maarten van Keulen
                        </h5>
                        <h3>
                            Founder, teacher success
                        </h3>
                    </b-card>
                </slide>
                <slide>
                    <b-card class="team-member">
                        <div class="avatar-linkedin-wrapper">
                            <img
                                src="../assets/images/jesse.png"
                                class="crop-circle"
                            />
                        </div>
                        <h5>
                            Jesse van den Ende
                        </h5>
                        <h3>
                            Development & Support
                        </h3>
                    </b-card>
                </slide>
                <slide>
                    <b-card class="team-member">
                        <div class="avatar-linkedin-wrapper">
                            <img
                                src="../assets/images/xavier.jpeg"
                                class="crop-circle"
                            />
                        </div>
                        <h5>
                            Xavier van Dommelen
                        </h5>
                        <h3>
                            Development & Support
                        </h3>
                    </b-card>
                </slide>
                <slide>
                    <b-card class="team-member">
                        <div class="avatar-linkedin-wrapper">
                            <img
                                src="../assets/images/team-member-2.png"
                                class="crop-circle"
                            />
                        </div>
                        <h5>
                            Rick Watertor
                        </h5>
                        <h3>
                            Development & Support
                        </h3>
                    </b-card>
                </slide>
                <slide>
                    <b-card class="team-member">
                        <div class="avatar-linkedin-wrapper">
                            <img src="../assets/images/robert.png" class="crop-circle"/>
                        </div>
                        <h5>
                            Robert van Wijk
                        </h5>
                        <h3>
                            Educational advisor
                        </h3>
                    </b-card>
                </slide>
                <slide>
                    <b-card class="team-member">
                        <div class="avatar-linkedin-wrapper">
                            <img
                                src="../assets/images/nina.jpg"
                                class="crop-circle"
                            />
                        </div>
                        <h5>
                            Nina Tuma
                        </h5>
                        <h3>
                            Financial advisor
                        </h3>
                    </b-card>
                </slide>
            </hooper>
        </b-row>
    </section>
</template>

<script>
import { Hooper, Slide } from 'hooper';
import 'hooper/dist/hooper.css';

export default {
    name: 'Testimonials',
    components: {
        Hooper,
        Slide,
    },
    mounted () {
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth
        })
    },
    data () {
        return {
            windowWidth: window.innerWidth,
        }
    },
    computed: {
        visibleCount () {
            if (this.windowWidth > 1200) {
                return 4
            }
            if (this.windowWidth > 900) {
                return 3
            }
            if (this.windowWidth > 600) {
                return 2
            }
            if (this.windowWidth > 400) {
                return 1.5
            }
            return 1
        },
        windowWidthVar () {
            return this.windowWidth
        },
    },
}
</script>

<style lang="sass">
@import '../sass/partials/shadows.sass'
@import '../sass/modules/breakpoints.sass'
@import '../sass/modules/colors.sass'

#team
    padding-bottom: 0px
    .hooper
        width: 100%
        margin: auto
        height: auto
        padding: 0px
        &::before, &::after
            content: ''
            position: absolute
            z-index: 1
            bottom: 0
            pointer-events: none
            width: 2em
            height: 100%
        &::before
            left: 0
            background-image: linear-gradient(to right, white, rgba(255,255,255,0))
        &::after
            right: 0
            background-image: linear-gradient(to left, white, rgba(255,255,255,0))
        .hooper-slide
            padding: 0px 20px 0px 40px
            .team-member
                @extend .theme-shadow
                display: inline-block
                border-radius: 20px
                width: 100%
                margin-top: 55px
                margin-bottom: 20px
                h3
                    margin-bottom: 0px
                .avatar-linkedin-wrapper
                    position: relative
                    height: 150px
                    width: 150px
                    margin: -75px auto 20px -40px
                    img
                        @extend .theme-shadow
                        user-select: none
                        width: 100%
                        height: 100%
                    .btn
                        @extend .theme-shadow, .hover
                        position: absolute
                        bottom: 0
                        right: 0
                        width: 40px
                        height: 40px
                        margin: 0px 10px 0px 0px
                        svg
                            position: absolute
                            left: 50%
                            top: 50%
                            transform: translate(-50%, -50%)
                            margin: 0px
</style>
